import { appliancesConstants, applianceConstants } from "../_constants";
import { appliancesService } from "../_services";
import { alertActions } from "./";
//import { history } from '../_helpers';

export const appliancesActions = {
  getDetail,
  setTab,
  setDetailItem
};

function setDetailItem(timestamp) {
  return dispatch => {
    dispatch(setItem(timestamp));
  };

  function setItem(timestamp) {
    return { type: appliancesConstants.SET_DETAIL_ITEM, timestamp };
  }
}

function getDetail(user, viewType) {
  return dispatch => {
    dispatch(request());

    appliancesService.getDetail(user, viewType).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: appliancesConstants.DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: appliancesConstants.DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: appliancesConstants.DETAIL_FAILURE, error };
  }
}

function setTab(tab) {
  return dispatch => {
    dispatch(setTab(tab));
  };

  function setTab(tab) {
    return { type: appliancesConstants.SET_TAB, tab };
  }
}
